import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import DailyEnergyCurve from './CurveTab/DailyEnergyCurve';
import DailyEnergyLogs from './LogTab/DailyEnergyLogs';
import { Box, CssBaseline, useTheme } from '@mui/material';
import DailyEnergySummary from './DailyEnergySummary/DailyEnergySummary';

function DailyReportTab() {
    const [key, setKey] = useState('Energy Log');
    const { spacing } = useTheme()
    return (
        <>
            <CssBaseline />
            <Box sx={{ bgcolor: 'background.default', py: spacing(1) }}>
                <Tabs
                    style={{ justifyContent: "flex-start", }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="Energy Log" title="Energy Log">
                        <DailyEnergyLogs />
                    </Tab>

                    <Tab eventKey="Energy Curve" title="Energy Curve">
                        <DailyEnergyCurve />
                    </Tab>

                    <Tab eventKey="Daily Energy Summary" title="Daily Energy Summary">
                        <DailyEnergySummary />
                    </Tab>



                </Tabs>
            </Box>
        </>
    )
}

export default DailyReportTab
